(function () {

    angular
        .module('ngmvac')
        .directive('carDatepicker', CarDatePicker);

    function CarDatePicker() {
        return {
            link: function (scope, element, attrs) {

                var startDate = "-0d";
               	
                $('#carFhInicio').val( moment().add(2 ,'days').format('YYYY-MM-DD') );
                $('#carFhFin').val( moment().add(4, 'days').format('YYYY-MM-DD') );

                $("#carFhInicio").datepicker({
                    format: "yyyy-mm-dd",
                    todayBtn: "linked",
                    language: 'es',
                    startDate: startDate,
                    orientation: "auto"
                });

                $('#carTwoStepInicio').datepicker({
                    format: "yyyy-mm-dd",
                    todayBtn: "linked",
                    language: 'es',
                    startDate: startDate,
                    orientation: "auto"
                });

                $('#carTwoStepFin').datepicker({
                    format: "yyyy-mm-dd",
                    todayBtn: "linked",
                    language: 'es',
                    startDate: moment($("#carTwoStepInicio").val()).format("YYYY-MM-DD"),
                    orientation: "auto"
                });
					

                $(element).on('changeDate', function (e) {
                    
					if( e.target.id == 'carFhInicio' ) {

                        $("#carFhFin").datepicker({
							format: "yyyy-mm-dd",
							todayBtn: "linked",
							language: $("#langInput").val(),
                            startDate: moment(e.target.value).format('YYYY-MM-DD'),
							orientation: "auto"
						});

                        $('#carFhFin').datepicker('setStartDate', moment(e.target.value).add(1, 'days').format('YYYY-MM-DD'));
                        $('#carFhInicio').datepicker('hide');

						if( $(window).width() > 975 ){
							$('#carFhFin').datepicker('show');
                        }
						$("#carFhFin").val("");
                    
                    }

                    if( e.target.id == 'carFhFin' ) {
					
						if($('#carFhFin').val() != ""){
			    			$('#carFhFin').datepicker("hide");
			    		}
					}

                    if( e.target.id == 'carTwoStepInicio' ){
                        var startDate = moment(e.target.value).add(1,'days').format('YYYY-MM-DD');

                        $('#carTwoStepInicio').datepicker('hide');
                        $('#carTwoStepFin').datepicker('setStartDate', startDate);
                        $('#carTwoStepFin').datepicker('update', moment($('#carTwoStepInicio').val()).add(1, 'days').format('YYYY-MM-DD'));

                        if( $(window).width() > 975 ){
                            $('#carTwoStepFin').datepicker('show');
                        }
                        $('#carTwoStepFin').val('');

                    }

                    if( e.target.id == 'carTwoStepFin' ){
                        if($('#carTwoStepFin').val() != ''){
                            $('#carTwoStepFin').datepicker('hide');
                        }
                    }
                    
                });
            }
        }
    }

})();